import { useState } from "react";
import { Link } from "react-router-dom";
import MovieCard from "@/components/feature/MovieCard";
import { movies } from "@/mocks/movies";

type TabKey = "latest" | "hot" | "rating";

const tabs: { key: TabKey; label: string; icon: string }[] = [
  { key: "latest", label: "最新上线", icon: "ri-time-line" },
  { key: "hot", label: "热门推荐", icon: "ri-fire-line" },
  { key: "rating", label: "高分佳作", icon: "ri-star-line" },
];

export default function FeaturedGrid() {
  const [tab, setTab] = useState<TabKey>("latest");

  const sorted = [...movies].sort((a, b) => {
    if (tab === "latest") return b.updated.localeCompare(a.updated);
    if (tab === "hot") return b.hot - a.hot;
    return b.rating - a.rating;
  });
  const list = sorted.slice(0, 10);

  return (
    <section className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              <Link to="/category">精选影视</Link>
            </h2>
            <p className="mt-2 text-sm text-foreground-600">最新上线、热门推荐与高分佳作，一网打尽</p>
          </div>
          <div className="flex items-center gap-1 rounded-full border border-background-200/70 bg-background-50 p-1">
            {tabs.map((t) => (
              <button
                key={t.key}
                type="button"
                onClick={() => setTab(t.key)}
                className={`flex items-center gap-1 whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm font-medium transition-colors ${
                  tab === t.key
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-600 hover:text-foreground-950"
                }`}
              >
                <i className={`${t.icon} leading-none`}></i>
                {t.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-5 lg:grid-cols-5">
          {list.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>

        <div className="mt-8 flex justify-center">
          <Link
            to="/category"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-primary-300 bg-background-50 px-6 py-3 text-sm font-bold text-primary-700 transition-colors hover:bg-primary-50"
          >
            浏览全部影视
            <i className="ri-arrow-right-line leading-none"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}